import queryString from "query-string";

import { COMMENT, DEPLOYMENT_SALE_COMMENT } from "constants/actionTypes";
import { userTypes } from "constants/users";

import { serializeComment } from "lib/serializers/comments";

import { getIsFetchingComments } from "selectors/root";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const commentsUrlCreator = ({
  changesSince,
  livestockSaleId,
  commentType,
  id,
  action,
} = {}) => {
  const query = { changesSince };

  if (livestockSaleId) {
    query.livestock_sale_id = livestockSaleId;
  }

  if (commentType) {
    query.comment_type = commentType;
  }

  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction(`/v2/comments/`, id, action),
    query,
  });
};

export const CommentAction = offlineActionCreator(
  COMMENT,
  serializeComment,
  commentsUrlCreator,
  true,
);

CommentAction.actionFilter = (state, changes = false) => {
  // Comments are not an explicit permission, request them for livestock agents and saleyard admins.
  const allowedRoleTypes = [
    userTypes.LIVESTOCK_AGENT,
    userTypes.SALEYARD_ADMIN,
  ];

  const enabled = allowedRoleTypes.includes(state.auth.activeRole.type); // Didn't use a getter because of cyclic import issue.
  if (!enabled) {
    return null;
  } else if (!changes) {
    return CommentAction.request();
  } else if (changes && !getIsFetchingComments(state)) {
    return CommentAction.requestChanges({
      changesSince: state.comments.lastModifiedTimestamp,
    });
  } else {
    // we requested changes but are fetching already.
    return null;
  }
};

// Deployment sale comments are used on the dashboard, where we are not within an individual sale,
// so we need to set livestockSaleSensitive to false for deployment sale comments. Instead of retrieving
// all comments specific to a sale, we are with a getting all comments with a type of DEPLOYMENT_SALE.
export const DeploymentSaleCommentAction = offlineActionCreator(
  DEPLOYMENT_SALE_COMMENT,
  serializeComment,
  commentsUrlCreator,
  false,
);
